import { css, SimpleInterpolation } from 'styled-components';

const flex = (percent: string) => (maxWidth?: string): SimpleInterpolation => css`
   ${maxWidth
      ? css`
           --flex-width: calc(${maxWidth} - var(--flex-gap));
           min-width: var(--flex-width);
           max-width: var(--flex-width);
           margin-right: calc(${percent} - var(--flex-width) - var(--flex-gap));
        `
      : css`
           --flex-width: calc(${percent} - var(--flex-gap));
           min-width: var(--flex-width);
           max-width: var(--flex-width);
           /* flex: 1 calc(${percent} - var(--flex-gap, 0)); */
        `}
`;

// TODO: https://dreryk.atlassian.net/browse/DREGAB-2680 Refactor needed
export const flexStyles = {
   whole: flex('100%'),
   half: flex('50%'),
   oneThird: flex('33%'),
   quarter: flex('25%'),
   eighth: flex('12.5%'),
   sixteenth: flex('6.25%'),
   layout: (gap: string, ...elementStyles: SimpleInterpolation[]): SimpleInterpolation[] => {
      return [
         css`
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            --flex-gap: ${gap};
            gap: var(--flex-gap, 0);
         `,
         elementStyles.map(
            (interpolation, index) => css`
               > *:nth-child(${index + 1}) {
                  ${interpolation}
               }
            `
         ),
      ];
   },
};
